
import PhoneNumber from 'awesome-phonenumber'
import store from '../config/store'

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    wrapperClass: {
      type: String,
      required: false,
      default: ''
    }
  },

  data: () => ({
    store,
    phone_country: {
      dial_code: '+221',
      code: 'SN'
    },
    phone_national: ''
  }),

  computed: {
    fullNumber () {
      return this.phone_country.dial_code + this.phone_national
    },

    flagSrc () {
      const countryCode = store.countriesDialCode.find(item => item.code === this.phone_country.code)
      if (countryCode && countryCode.code) {
        return `https://static.manager.one/flags/country/${countryCode.code}.png`
      }
      return false
    }
  },

  watch: {
    value () {
      this.formatNumber()
    },

    fullNumber () {
      this.$emit('input', this.fullNumber)
    }
  },

  mounted () {
    this.formatNumber()
  },

  methods: {
    formatNumber () {
      if (this.value !== null) {
        let phone = new PhoneNumber(this.value, 'SN')
        let countryCode = phone.getRegionCode()
        if (!countryCode) {
        const country = store.countriesDialCode.find(country => country.dial_code === this.value)
          if (country && country.code) {
            countryCode = country.code
          }
        }
        this.phone_country = store.countriesDialCode.find(country => country.code === countryCode)
        if (phone.isValid()) {
          this.phone_national = phone.getNumber('significant')
        } else if (this.value === '') {
          this.phone_national = ''
        }
      }
    },

    onImageLoaded () {
      document.getElementById('phone-flag').classList.remove('hide')
    },

    onImageError () {
      document.getElementById('phone-flag').classList.add('hide')
    }
  }
}
